import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import type { TypeShippingLabelCancelFailure } from '~/types/delivery-agency.types';

const getDeliveryAgencyTrackingCancelFailColumnDefs = () => {
  const columnDefs: ColDef<TypeShippingLabelCancelFailure>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'outboundCode',
      headerName: '출고 번호',
      width: 160,
    },
    {
      field: 'clientOrderCodes',
      headerName: '판매처 주문번호',
      minWidth: 620,
      flex: 1,
      wrapText: true,
      autoHeight: true,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeShippingLabelCancelFailure, TypeShippingLabelCancelFailure['clientOrderCodes']>) =>
        value?.join(', ') ?? '-',
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyTrackingCancelFailColumnDefs;
